module.exports = __webpack_public_path__ + "static/media/alligator.b63265bd.ogg";